module.exports = __webpack_public_path__ + "df467e08bfd2a6a8226d4f817ada85a9.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/dummy_image_horse.png
// module id = 86
// module chunks = 0